import React from "react";
import ForgotPassword from "../pages/forgot-password/page";
import Login from "../pages/login/page";
import Menu from "../pages/menu/page";
import Otp from "../pages/otp/page";
import PageNotFound from "../pages/page-not-found/PageNotFound";
import Review from "../pages/review/page";
import AboutUs from '../pages/about/page'
import MenuSelection from "../pages/menu-selected/MenuSelection";
import SomethingWrong from "../pages/something-wrong/SomethingWrong";

const WithoutProtectdRouter = [
  {
    path: "/",
    element: <Menu />,
  },
  {
    path: "*",
    element: <PageNotFound />,
  },
  {
    path: "/login",
    element: <Login />,
  },
  {
    path: "/forgot-password",
    element: <ForgotPassword />,
  },

  {
    path: "/menu",
    element: <Menu />,
  },
  {
    path: "/menu/:id",
    element: <MenuSelection />,
  },
  {
    path: "/verify-otp",
    element: <Otp />,
  },
  {
    path: 'review',
    element: <Review />,
  },
   {
    path: 'about',
    element: <AboutUs />,
  },
  {
    path:'/something-wrong',
    element:<SomethingWrong />
  }
  

];

export default WithoutProtectdRouter;
